import React from "react"
import PropTypes from "prop-types"
import { find, sortBy, max, reverse, isNumber } from "lodash"

import {
  Modal, Radio, FormGroup, FormControl, ControlLabel
} from "react-bootstrap"

import { printMoney } from "../../lib/Tools"
import { emptyPrice as _emptyPrice, normalizePrice } from "../../lib/prices"
import { eur2yuan } from "../lib/exchangeRateClient"
import { getText } from "../lib/text"
import Button from "../components/Button"

/* i havent been able to make this work. sthg server-side imports this.
 * i move this import to app/index.js
 */
// import "./Price.less"

/* Re-export empty price */

export const emptyPrice = _emptyPrice

/* Simple tag-looking tag for a priceValue */

export const CutePriceTag = ({ style, priceValue }) => (
  isNumber(priceValue) && (
    <div className="cute-tag" style={style || {}}>
      {`${printMoney(priceValue)}€`}
    </div>
  )
)


/* Render Price */

const tag = (eur, withYuan) => (
  withYuan ? `${printMoney(eur)}€ (¥${printMoney(eur2yuan(eur))})` : `${printMoney(eur)}€`
)

// #TODO #DUPLICATION this is very close to VisualPrice
export const Price = ({ label, price, withYuan, style }) => {
  const np = normalizePrice(price)
  return (
    <p style={style}>
      {
        (
          np.perGroup && (
            <span>{label ? `${label}: ` : ""}{getText("Grupo")} {tag(np.general, withYuan)}</span>
          )
        ) || (
          // #TODO use tag here
          np.ageAware && (
            <span>
              {label ? `${label}: ` : ""}
              {
                [
                  `> ${np.agePrices.length ? "Mayores" : ""}: ${tag(np.general)}`,
                  ...np.agePrices.map(({ age, price }) => `≤${age}: ${tag(price)}`)
                ].join(", ")
              }
            </span>
          )
        ) || (
          <span>{label ? `${label}: ` : ""}{tag(np.general)}</span>
        )
      }
    </p>
  )
}

Price.propTypes = {
  price: PropTypes.object.isRequired,
  withYuan: PropTypes.bool,
  label: PropTypes.string,
  style: PropTypes.object,
}

Price.defaultProps = {
  label: "Precio",
  withYuan: true,
  style: {}
}

/* Edit prices */

const PriceInput = ({ label, value, onChange, disabled }) => (
  <FormGroup bsSize="small">
    <ControlLabel
      style={{display: "inline-block", fontWeight: 400}}
    >
      {label}
    </ControlLabel>
    <FormControl
      value={value}
      type="number"
      style={{display: "inline-block", width: 90, marginLeft: 10, marginRight: 10}}
      onChange={evt => {
        onChange(evt.target.value)
      }}
      disabled={disabled}
    />
    (¥{eur2yuan(Number.parseFloat(value) || 0).toFixed(2)})
  </FormGroup>
)

PriceInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
}
PriceInput.defaultProps = {
  disabled: false
}

// TODO validate price forms

type PriceEditorProps = {
  price: Object,
  onChange: (string, any) => void, // onChange(newPrice)
  disabled: boolean
}

export const PriceEditor = props => (
  <_PriceEditor {...{...props, price: normalizePrice(props.price)}} />
)

const _PriceEditor = (props : PriceEditorProps) => {
  // #TODO use this for the age-prices too
  function priceChange(k, v) {
    const kk = `__${k}`
    const n = Number.parseFloat(v)
    props.onChange({
      ...props.price,
      [k]: n,
      [kk]: v
    })
  }

  const { price, disabled } = props
  const { kidsDifferent, ageAware, perGroup } = props.price

  function onChange(newPrice) {
    console.log({newPrice})
    props.onChange(newPrice)
  }

  function onRadioChange(evt, change) {
    if (evt.target.checked) onChange(Object.assign({}, props.price, change))
  }

  return (
    <div className="price-editor">
      {
        ageAware && (
          <div className="age-aware">
            <PriceInput
              label={
                `${price.agePrices.length
                  ? (getText("Mayores de ") + max(price.agePrices.map(({age}) => age)))
                  : getText("Cualquier edad")
                } (€)`
              }
              value={props.price.__general || props.price.general}
              onChange={v => priceChange("general", v)}
              disabled={disabled}
            />
            {
              (props.price.agePrices || []).map(({ price, __price, age }, i) => (
                // #TODO inline this
                <div className="age-price" key={age}>
                  <PriceInput
                    label={`≤${age}`}
                    value={__price || price}
                    onChange={v => onChange({
                      ...props.price,
                      agePrices: props.price.agePrices.map((point, j) => (
                        i === j ? {
                          ...point,
                          price: parseInt(v || 0),
                          __price: v,
                        } : point
                      ))
                    })}
                    disabled={disabled}
                  />
                  <Button
                    bsStyle="link"
                    glyph="remove"
                    onClick={() => {
                      onChange({
                        ...props.price,
                        agePrices: props.price.agePrices.filter(x => x.age != age)
                      })
                    }}
                  />
                </div>
              ))
            }
            <Button
              glyph="plus"
              onClick={() => {
                const text = prompt("Edad máxima para el nuevo precio")
                if (!text) return;

                const newAge = parseInt(text)
                if (find(props.price.agePrices, ({age}) => age == newAge)) return;

                onChange({
                  ...props.price,
                  agePrices: reverse(sortBy([
                    ...(props.price.agePrices || []),
                    {
                      price: 0,
                      age: newAge
                    }
                  ], "age"))
                })
              }}
            >
              Añadir edad
            </Button>
          </div>
        )
      }

      {
        !ageAware && !kidsDifferent && (
          <PriceInput
            label={`${perGroup ? getText("Por grupo") : getText("Por persona")} (€):`}
            value={props.price.__general || props.price.general}
            onChange={v => priceChange("general", v)}
            disabled={disabled}
          />
        )
      }

      <FormGroup style={{marginBottom: 0}}>
        <Radio
          inline
          checked={!perGroup && !kidsDifferent && !ageAware}
          onChange={evt => onRadioChange(evt, { ageAware: false, perGroup: false, kidsDifferent: false })}
          disabled={disabled}
        >
          {getText("Por persona")}
        </Radio>
        {' '}
        <Radio
          inline
          checked={ageAware}
          onChange={evt => onRadioChange(evt, { ageAware: true, perGroup: false, kidsDifferent: false })}
          disabled={disabled}
        >
          {getText("Por edad")}
        </Radio>
        {' '}
        <Radio
          inline
          checked={perGroup}
          onChange={evt => onRadioChange(evt, { ageAware: false, perGroup: true, kidsDifferent: false })}
          disabled={disabled}
        >
          {getText("Por grupo")}
        </Radio>

      </FormGroup>
    </div>
  )
}

PriceEditor.defaultProps = {
  disabled: false
}

type ModalPriceEditorProps = {
  price: Object,
  onChange: (string, any) => void, // onChange(newPrice)
  onClose: () => void,
  title: string,
}

export const ModalPriceEditor = ({ price, onChange, onClose, title } = ModalPriceEditorProps) => (
  <Modal show onHide={() => onClose()}>
    <Modal.Header>{title || getText("Precio")}</Modal.Header>
    <Modal.Body>
      <PriceEditor
        price={price}
        onChange={changed => { onChange(changed) }}
      />
    </Modal.Body>
    <Modal.Footer>
      <Button bsStyle="success" onClick={() => onClose()}>
        {getText("OK")}
      </Button>
    </Modal.Footer>
  </Modal>
)
